import { ContextWindow } from "@asup/context-menu";
import { isEqual } from "lodash";
import { AitCommentRow } from "./AitCommentRow";
import { AitRowGroupReplacements } from "./AitRowGroupReplacements";
import { AitRowHeaderColumns } from "./AitRowHeaderColumns";
import { getBaseId } from "./functions/getBaseId";
import {
  AitLocationHeader,
  AitRowType,
  AitTablePosition,
  HIDE_OPTIONS_WINDOW,
} from "./functions/interface";
import { useTableContext } from "./TableContextProvider";

/**
 * Render the header options window when applicable.
 */
export const AitHeaderOptionsWindow = () => {
  const { state, dispatch } = useTableContext();
  const headerData = state?.processedTableData?.headerData;
  const location: AitLocationHeader = {
    position: AitTablePosition.header,
    tableSection: AitRowType.header,
    rowGroup: 0,
    rowGroupId: headerData ? headerData.aitid : "",
  };
  const id = getBaseId(location, state?.id);

  return !headerData ? null : (
    <ContextWindow
      id={`${id}-header-options-window`}
      title={"Header options"}
      visible={state.showOptionsWindow.findIndex((l) => isEqual(l, location)) > -1}
      onClose={() => {
        dispatch({
          operation: HIDE_OPTIONS_WINDOW,
          location,
        });
      }}
      style={{ maxHeight: "75vh" }}
    >
      <AitCommentRow location={location} />
      <AitRowHeaderColumns />
      <AitRowGroupReplacements location={location} />
    </ContextWindow>
  );
};

AitHeaderOptionsWindow.displayName = "AitHeaderOptionsWindow";
